// tslint:disable


import { NgModule, EventEmitter, OnInit, ViewEncapsulation, Component, Input, Output, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NzUploadModule, NzMessageService, UploadFile } from 'ng-zorro-antd';
import { YztUploadFile } from './interface';
declare let _;
export class YztUploadComponent implements OnInit {

    action = `baseConfig/uploadFile`;

    loading = false;

    avatarUrl: string;

    previewImage = '';

    previewVisible = false;

    _fileList: YztUploadFile[] | string = [];

    
    type = 'basic'; // 样式类型 'basic' | 'avatar' | 'picture-card' | 'picture' | 'picture-inline' | 'drag'

    
    valueType = 'array'; // 值类型 'string' | 'array'

    
    fileSize = 0; // 	限制文件大小，单位：KB；0 表示不限

    
    fileNum = 50; // 	限制上传文件数量，单位：个/张；默认50

    
    fileAccept: string = "image/*";

    
    disabled: boolean;

    
    fileType: string; // 限制文件类型，例如： image/png,image/jpeg,image/gif,image/bmp

    
    multiple: boolean = true; // 是否支持多选

    
    beforeUpload; // nzBeforeUpload

    
    removeHandler; // nzRemove

    
    uploadLabel = '上传';
/**
 * @param {?} files
 * @return {?}
 */
set fileList(files: YztUploadFile[] | string) {
        this._fileList = this.getYztUploadFiles(files);
    }
/**
 * @return {?}
 */
get fileList(): YztUploadFile[] | string {
        return this._fileList;
    }


    
    fileListChange: EventEmitter<YztUploadFile[] | string> = new EventEmitter<YztUploadFile[] | string>();

    
    onChange: EventEmitter<YztUploadFile[] | string> = new EventEmitter<YztUploadFile[] | string>();
/**
 * @param {?} msg
 * @param {?} BASEURL
 */
constructor(private msg: NzMessageService,
private BASEURL) { }
/**
 * @return {?}
 */
ngOnInit(): void {
        this._fileList = this.getYztUploadFiles(this.fileList);
    }

    handlePreview = (file: UploadFile) => {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
    }
/**
 * @param {?} img
 * @param {?} callback
 * @return {?}
 */
private getBase64(img: File, callback: (img: any) => void) {
        const /** @type {?} */ reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }
/**
 * @param {?} info
 * @return {?}
 */
handleChange(info: { file: UploadFile, fileList: any[] }) {
        if (info.file.status === 'uploading') {
            this.loading = true;
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            this.getBase64(info.file.originFileObj, (img: any) => {
                this.loading = false;
                this.avatarUrl = img;
            });
        }

        let /** @type {?} */ files = this.getYztUploadFiles(info.fileList);
        if (this.valueType === 'string') {
            this.fileListChange.emit(_.map(files, 'url').join(','));
        } else {
            this.fileListChange.emit(files);
        }
        this.onChange.emit(files);
    }
/**
 * @param {?=} files
 * @return {?}
 */
getYztUploadFiles(files: any = this._fileList): YztUploadFile[] | string {

        if (typeof files === 'string' && files.length > 0) {
            let /** @type {?} */ urls = files.split(',');
            files = [];
            urls.forEach(url => {
                let /** @type {?} */ index = url.lastIndexOf('/');
                files.push({
                    _id: new Date().getTime(),
                    url: url,
                    name: url.substr(index) || ''
                })
            })
        } else {
            files = files || [];
        }
        let /** @type {?} */ result = new Array(files.length);
        let /** @type {?} */ count = -1;
        files.forEach(file => {
            count++;
            if (!file._id) {
                file.status = file.status || 'done';
                let /** @type {?} */ resp = file.response;
                if ((resp && resp.resultCode == '200' && resp.content)) {
                    file._id = resp.content._id
                    file.url = resp.content.path || file.path;
                }
                /*  if ((file.response && file.response[0])) {
                     file.key = file.response[0].key
                     file.url = file.response[0].path || file.path;
                 } */
                file.message = file.key ? '上传失败' : ''
                delete file.response;
            }

            result[count] = {
                _id: file._id,
                url: file.url,
                name: file.name,
                thumbUrl: file.thumbUrl,
                status: file._id ? 'done' : 'error',
                message: file._id ? '' : '上传失败'
            };
        });
        if (files.length >= this.fileNum) {
            this.disabled = true;
        }
        return result;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'yzt-upload',
    template: `
    <ng-template [ngIf]="type==='basic'">
        <nz-upload
            [nzAction]="action"
            [nzFileType]="fileType"
            [(nzFileList)]="_fileList"
            (nzChange)="handleChange($event)"
            [nzSize]="fileSize"
            [nzAccept]="fileAccept"
            [nzMultiple]="multiple"
            [nzDisabled]="disabled"
            [nzShowButton]="_fileList.length < fileNum"
            [nzRemove]="removeHandler"
            >
            <button nz-button  [disabled]="disabled">
            <i class="anticon anticon-upload"></i><span>{{uploadLabel}}</span>
            </button>
        </nz-upload>
    </ng-template>
    <ng-template [ngIf]="type==='avatar'">
        <nz-upload class="avatar-uploader"
            [nzAction]="action"
            [(nzFileList)]="_fileList"
            nzName="avatar"
            [nzAccept]="fileAccept"
            [nzSize]="fileSize"
            [nzDisabled]="disabled"
            [nzShowButton]="_fileList.length < fileNum"
            [nzShowUploadList]="false"
            [nzBeforeUpload]="beforeUpload"
            (nzChange)="handleChange($event)">
            <i *ngIf="!avatarUrl" class="anticon anticon-plus avatar-uploader-trigger"></i>
            <img *ngIf="avatarUrl" [src]="avatarUrl" class="avatar">
        </nz-upload>
    </ng-template>
    <ng-template [ngIf]="type==='picture-card'">
        <nz-upload
            class="yzt-upload-picture-card"
            [nzAction]="action"
            [(nzFileList)]="_fileList"
            nzListType="picture-card"
            [nzSize]="fileSize"
            [nzAccept]="fileAccept"
            [nzDisabled]="disabled"
            [nzMultiple]="multiple"
            [nzShowButton]="_fileList.length < fileNum"
            (nzChange)="handleChange($event)"
            [nzRemove]="removeHandler"
            [nzPreview]="handlePreview">
                <i class="anticon anticon-plus"></i>
                <div class="ant-upload-text">{{uploadLabel}}</div>
            </nz-upload>
            <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null" (nzOnCancel)="previewVisible=false">
            <ng-template #modalContent>
                <img [src]="previewImage" [ngStyle]="{ 'width': '100%' }" />
            </ng-template>
        </nz-modal>
    </ng-template>
    <ng-template [ngIf]="type==='picture'">
        <nz-upload
            [nzAction]="action"
            nzListType="picture"
            [nzAccept]="fileAccept"
            [nzDisabled]="disabled"
            [nzMultiple]="multiple"
            [nzRemove]="removeHandler"
            (nzChange)="handleChange($event)"
            [(nzFileList)]="_fileList">
            <button nz-button  [disabled]="disabled">
                <i class="anticon anticon-upload"></i><span>{{uploadLabel}}</span>
            </button>
        </nz-upload>
    </ng-template>
    <ng-template [ngIf]="type==='picture-inline'">
        <nz-upload class="upload-list-inline"
            [nzAction]="action"
            nzListType="picture"
            [nzMultiple]="multiple"
            [nzAccept]="fileAccept"
            [nzShowButton]="_fileList.length < fileNum"
            [nzDisabled]="disabled"
            [nzRemove]="removeHandler"
            (nzChange)="handleChange($event)"
            [(nzFileList)]="_fileList">
            <button nz-button  [disabled]="disabled">
                <i class="anticon anticon-upload"></i><span>{{uploadLabel}}</span>
            </button>
        </nz-upload>
    </ng-template>
    <ng-template [ngIf]="type==='drag'">
        <nz-upload class="yzt-upload-drag"
            nzType="drag"
            [nzAction]="action"
            [nzMultiple]="multiple"
            [nzAccept]="fileAccept"
            [nzDisabled]="disabled"
            [nzLimit]="fileNum"
            [nzRemove]="removeHandler"
            (nzChange)="handleChange($event)">
            <p class="ant-upload-drag-icon">
            <i class="anticon anticon-inbox"></i>
            </p>
            <p class="ant-upload-text">点击选择或将图片拖到这里</p>
        </nz-upload>
    </ng-template>
    `,
    styles: [`
    .avatar-uploader,
    .avatar-uploader-trigger,
    .avatar {
      width: 150px;
      height: 150px;
      display: block;
    }
  
    .avatar-uploader {
      display: block;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
    }
  
    .avatar-uploader-trigger {
      display: table-cell;
      vertical-align: middle;
      font-size: 28px;
      color: #999;
    }
    .yzt-upload-picture-card i {
        font-size: 32px;
        color: #999;
      }
    .yzt-upload-picture-card .ant-upload-text {
        margin-top: 8px;
        color: #666;
      }

      .upload-list-inline .ant-upload-list-item {
        float: left;
        width: 200px;
        margin-right: 8px;
      }

      .yzt-upload-drag { display: block; }
      .yzt-upload-drag .ant-upload.ant-upload-drag { height: 180px; }
    `],
    encapsulation: ViewEncapsulation.None,
    preserveWhitespaces: false
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NzMessageService, },
{type: undefined, decorators: [{ type: Inject, args: ['API_BASE_URL', ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input },],
'valueType': [{ type: Input },],
'fileSize': [{ type: Input },],
'fileNum': [{ type: Input },],
'fileAccept': [{ type: Input },],
'disabled': [{ type: Input },],
'fileType': [{ type: Input },],
'multiple': [{ type: Input },],
'beforeUpload': [{ type: Input },],
'removeHandler': [{ type: Input },],
'uploadLabel': [{ type: Input },],
'fileList': [{ type: Input },],
'fileListChange': [{ type: Output },],
'onChange': [{ type: Output },],
};
}

function YztUploadComponent_tsickle_Closure_declarations() {
/** @type {?} */
YztUploadComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YztUploadComponent.ctorParameters;
/** @type {?} */
YztUploadComponent.propDecorators;
/** @type {?} */
YztUploadComponent.prototype.action;
/** @type {?} */
YztUploadComponent.prototype.loading;
/** @type {?} */
YztUploadComponent.prototype.avatarUrl;
/** @type {?} */
YztUploadComponent.prototype.previewImage;
/** @type {?} */
YztUploadComponent.prototype.previewVisible;
/** @type {?} */
YztUploadComponent.prototype._fileList;
/** @type {?} */
YztUploadComponent.prototype.type;
/** @type {?} */
YztUploadComponent.prototype.valueType;
/** @type {?} */
YztUploadComponent.prototype.fileSize;
/** @type {?} */
YztUploadComponent.prototype.fileNum;
/** @type {?} */
YztUploadComponent.prototype.fileAccept;
/** @type {?} */
YztUploadComponent.prototype.disabled;
/** @type {?} */
YztUploadComponent.prototype.fileType;
/** @type {?} */
YztUploadComponent.prototype.multiple;
/** @type {?} */
YztUploadComponent.prototype.beforeUpload;
/** @type {?} */
YztUploadComponent.prototype.removeHandler;
/** @type {?} */
YztUploadComponent.prototype.uploadLabel;
/** @type {?} */
YztUploadComponent.prototype.fileListChange;
/** @type {?} */
YztUploadComponent.prototype.onChange;
/** @type {?} */
YztUploadComponent.prototype.handlePreview;
/** @type {?} */
YztUploadComponent.prototype.msg;
/** @type {?} */
YztUploadComponent.prototype.BASEURL;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
